export const defkey = Symbol('SchemaDefinition');
